/*
 * $Id:: service.js 2021/03/02 11:11 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { sendRequest } from '../../common/utils';

export const deleteApplication = (params) => {
    const { appId, ipRightType, applicationType } = params;
    const appRightType = (ipRightType || applicationType).toLowerCase();
    return sendRequest({
        url: `/applications/${applicationType}/${appRightType}/${appId}`,
        method: 'DELETE',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code, details: error.details } };
        });
};

export const resumeApplication = (params) => {
    const { appId, ipRightType, applicationType } = params;
    const appRightType = (ipRightType || applicationType).toLowerCase();
    return sendRequest({
        url: `/applications/${applicationType}/${appRightType}/${appId}/resume`,
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code, details: error.details } };
        });
};

export const lockApplication = (params) => {
    const { appId, ipRightType, applicationType } = params;
    const appRightType = (ipRightType || applicationType).toLowerCase();
    return sendRequest({
        url: `/applications/${applicationType}/${appRightType}/${appId}/lock`,
        method: 'POST',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const unlockApplication = (params) => {
    const { appId, ipRightType, applicationType } = params;
    const appRightType = (ipRightType || applicationType).toLowerCase();
    return sendRequest({
        url: `/applications/${applicationType}/${appRightType}/${appId}/unlock`,
        method: 'POST',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};
